import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function ShareInvitationDialog(props) {

    const [url, setUrl] = useState('');
    const [confirmationVisible, setConfirmationVisible] = useState('hidden');

    const textAreaRef = React.createRef();

    function initFields() {
        setUrl(props.invitationUrl);
        setConfirmationVisible('hidden');
    }

    function copyUrl() {
        textAreaRef.current.select();
        document.execCommand('copy');
        setConfirmationVisible('visible');
    }

    function handleSubmit(event) {

        event.preventDefault();
        event.stopPropagation();
        props.onHide();
        return;
    }

    return (
        <Modal show={props.show} onShow={initFields} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Share your invitation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={false} onSubmit={(event) => { handleSubmit(event); }}>
                    <div>
                        Copy the following URL and share it with {props.targetEmail}:
                    </div>
                    <div>
                        <textarea style={{ width: '100%' }} name='url' rows={3} value={url} readOnly ref={textAreaRef}/>
                    </div>

                    <Form.Group style={{ justifyContent: 'flex-end' }}>
                        <Button style={{ marginRight: '6px' }} onClick={copyUrl}><FontAwesomeIcon icon="copy" /> Copy</Button>
                        <Button onClick={props.onHide}>Close</Button>
                    </Form.Group>
                    <div style={{ visibility: confirmationVisible}}>Invitation URL has been copied to the clipboard.</div>
                </Form>
            </Modal.Body >
            <Modal.Footer>
                <div className='text-muted'>Note: the invitation will only be valid for the specified e-mail address.</div>
            </Modal.Footer>
        </Modal >
    );
}

export default ShareInvitationDialog;


// WEBPACK FOOTER //
// ./src/components/ShareInvitationDialog.js